import script from "./LayoutDashboard.vue?vue&type=script&lang=ts&setup=true"
export * from "./LayoutDashboard.vue?vue&type=script&lang=ts&setup=true"

import "./LayoutDashboard.vue?vue&type=style&index=0&id=d358b04c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d358b04c"]])

export default __exports__